export const SITE_ID = '961c3d60-205b-4c8d-b9b9-6679da4a408e';
export const ACCOUNT_ID = 'e76d7144-4293-4eaf-a8d9-00c289f47b5b';
export const OAUTH_CLIENT_ID = '2d34859d-f41c-47f8-bf3a-ee3371bb9a33';

export const DEFAULT_IMAGE_URL =
  'https://static.wixstatic.com/media/503ea4_ed9a38760ae04aab86b47e82525fdcac~mv2.jpg';

// https://github.com/wix-private/docs/blob/af7e6569cb1f8e257628de642168f6d4165e94fb/packages/docs-web-app/src/utils/portal-name-utils.ts#L17
export const SDK_PORTAL_ID = 'b85dea5b-341b-493b-b99e-4d4ca12baaa2';
export const REST_PORTAL_ID = 'd1972c09-74e2-4d36-a6f2-54e3310d4ad9';
export const VELO_PORTAL_ID = 'f356b938-ca2c-46f4-a390-e7ed146e00e0';
export const BUILD_APPS_PORTAL_ID = '63e3acd8-2a9c-421d-8f92-d02930eeb59e';
export const HEADLESS_PORTAL_ID = '4433709a-e41c-4551-ac9d-c21eecb23683';
export const DEVELOP_WEBSITES_PORTAL_ID =
  'bcc88c7b-94f5-4c35-b1cb-d7a20f2669b0';
export const FEDS_PORTAL_ID = '868d6f08-07d4-4fca-a289-d82611790482';
export const BEDS_PORTAL_ID = '4c3b5e5f-6c6d-4510-af2f-8fc8876506ee';
export const RND_GEN_PORTAL_ID = '411fb625-c942-491c-a3f6-5efd2170b865';
export const WIXTRO_PORTAL_ID = '9e5a6649-96ff-4a01-93a6-631b053e9471';

export const PORTAL_NAME_TO_ID: Record<string, string> = {
  SDK: SDK_PORTAL_ID,
  REST: REST_PORTAL_ID,
  VELO: VELO_PORTAL_ID,
  APPS: BUILD_APPS_PORTAL_ID,
  HEADLESS: HEADLESS_PORTAL_ID,
  DEVSITES: DEVELOP_WEBSITES_PORTAL_ID,
  FEDS: FEDS_PORTAL_ID,
  BEDS: BEDS_PORTAL_ID,
  RND: RND_GEN_PORTAL_ID,
};

export const LAST_CHUNK = '---{{{END}}}---';
export const EVENT_SOURCE_ERROR_MESSAGE = `Error: Something unexpected happened.\n\n&nbsp;\n\nPlease try again later or contact [support](https://www.wix.com/contact)`;

export const searchSuggestionsForAssistantType: Record<string, string[]> = {
  SDK: [
    'How do I create a blog post?',
    'How do I create a product?',
    'How do I use Webhooks?',
  ],
  REST: [
    'How do I create a blog post?',
    'How do I create a product?',
    'How do I filter query results?',
  ],
  VELO: [
    'How do I handle secrets?',
    'How do I handle routing?',
    'What is the realtime API?',
    'What are HTTP functions?',
  ],
  BUILD_APPS: [
    `What frameworks are there?`,
    `What is Wix Blocks?`,
    `What kind of extensions does the Wix CLI support?`,
    `What's the min NodeJS version required for the Wix CLI?`,
  ],
  UNIFIED: [
    'How do I create a blog post in REST?',
    'How do I create a product with the SDK?',
    'What is the Velo realtime API?',
    'How do I view logs for my website?',
    'How do I trigger an email?',
    'How do I create a custom element for the Wix Editor?',
  ],
  HEADLESS: [
    'Are there any templates?',
    'Are there any tutorials?',
    'How do I authenticate?',
    'Why would I use REST vs SDK?',
  ],
  DEVELOP_WEBSITES: [
    'How do I view logs for my website?',
    'How do I trigger an email?',
    'How do I create a custom element for the Wix Editor?',
  ],
  WDS: [
    'How do I create a toast?',
    'Color picker components',
    'Different types of buttons',
  ],
  CAIRO: ['How do I create a list of all products?'],
  WIXTRO: ['How do I get started?'],
};

export const isSuggestedQ = (q: string) => {
  return Object.values(searchSuggestionsForAssistantType).some((suggestions) =>
    suggestions.includes(q)
  );
};

// only public KBs:
// https://bo.wix.com/prompt-hub/kb/<kbId>
export const KB_IDS = async () => {
  return {
    REST_DOCS_KB_ID: '9ffb8287-02cb-45f7-97fb-96f746ad8cfe',
    REST_METHODS_KB_ID: '325bceae-723c-4b3f-8411-b1ff34045b81',
    SDK_DOCS_KB_ID: '19bf4afb-52ff-4dfd-a464-3e286a5d02c2',
    SDK_SCHEMAS_KB_ID: '293881ed-beff-4ea3-a53c-d6e86cb4a802',

    MCP_REST_RECIPES_KB_ID: '5af502a6-61d9-43db-bea8-0b493d2dfbe7',
    BEST_PRACTICES_KB_ID: 'b1da74d2-eabc-43f7-9b3e-56a4545320e0',
    // with summary:

    // new test kb - change chunk sizes, with/out summary, etc.:
    // SDK_SCHEMAS_KB_ID: 'ecd5926d-6a20-4fce-b5db-58e6ef15a7f8',

    BUILD_APPS_KB_ID: '2e4ed1b8-038f-4547-8fca-65582b60de77',
    VELO_DOCS_KB_ID: 'cecc4c6c-27c6-46cd-be7a-ae64ca21fd39',
    VELO_METHODS_KB_ID: 'e2cca716-c652-4ff7-8701-a5017dccf23b',
    HEADLESS_KB_ID: 'a9537660-9d4d-4e77-926d-322cc1463d49',
    DEVELOP_WEBSITES_KB_ID: '7b0e7961-5854-46c0-accd-8531d0c49eeb',

    WDS_DOCS_KB_ID: '89607851-7e72-45de-96d5-50c6270bc366',
  };
};

export const DIGOR_ADMIN_PERMISSION = 'WIX_DIGOR.ADMIN';

// https://bo.wix.com/prompt-hub/projects/907dad08-27e3-4aa7-bc28-d9b9ad8ef01f?promptId=<promptId>
export const SEARCH_DOCS_PROMPT_ID_NEW = 'a7a060d8-ce8c-415d-8584-4a3d701710d0';
export const SEARCH_DOCS_PROMPT_ID_MINI =
  '942be3a1-dced-4c68-8c9b-519f34aa82f5';
export const SEARCH_DOCS_PROMPT_ID_STREAM =
  'eae36d22-43a6-43ee-947e-16051ead8d41';
export const SEARCH_DOCS_PROMPT_ID_STREAM_MINI =
  'cc0450dd-1d17-4cbf-855f-ec634297de69';

export const VERY_SHORT_SUMMARY_PROMPT_ID =
  'd2948caf-a034-46b9-a1cb-3391d42138aa';
// only for SDK?
export const SEARCH_RELEVANT_METHODS_PROMPT_ID =
  '19be9d1e-f235-4eae-80aa-827dd384dcbe'; // SDK
export const GENERATE_SDK_CODE_EXAMPLE_PROMPT_ID =
  '34f08527-2dd8-4be9-8d67-6f652743e983';

export const GENERATE_VELO_CODE_EXAMPLE_PROMPT_ID =
  'e69afa03-fe38-4b2d-9761-3dad42c45daa';

export const GENERATE_REST_CODE_EXAMPLE_PROMPT_ID =
  '453ca988-311c-4208-9ccf-1f183360fa5d';

export const SYNTH_CODE_EXAMPLE_PROMPT_ID =
  '68645a55-85a0-4384-8c43-7b052b02e719';

export const SYNTH_CODE_EXAMPLE_PROMPT_ID_VELO =
  '5de2e7a8-3e31-4d56-80ee-03b5d7304a4c';

export const SEARCH_REST_RELEVANT_METHODS_PROMPT_ID =
  '08604e36-9d36-4794-970a-350db9b12fb2';
export const SEARCH_VELO_RELEVANT_METHODS_PROMPT_ID =
  '19be9d1e-f235-4eae-80aa-827dd384dcbe';
export const DOCS_SCHEMA_SUMMARY_PROMPT_ID =
  '7b6a8649-6837-48d1-8d0a-876e496f967c';
export const DOCS_SCHEMA_SUMMARY_PROMPT_ID_REST =
  'ab3ba12d-2e75-4629-8743-87de5ee25a4c';
export const EVAL_PROMPT_ID = 'e15c3338-31da-4104-b3d5-e650a8801c22';
export const SEARCH_DOCS_AND_CODE_PROMPT_ID =
  '62097f71-e01f-45b7-90ea-06b6842360c5';
export const SEARCH_WDS_DOCS_SIMPLE_PROMPT_ID =
  'a7f93ada-a878-4acd-95b0-f58313112754';
export const SEARCH_WDS_DOCS_AND_CODE_PROMPT_ID =
  'a1cefe30-8f96-47d8-8a44-a7b1bc67bf94';
export const SEARCH_CAIRO_DOCS_PROMPT_ID =
  '5bc4216f-03ab-4680-aab6-010667479659';
export const RERANKER_PROMPT = 'ac39b41f-870f-4b49-9354-55fc6ad000f0';
export const RERANKER_PROMPT_ALL_DOCS = '7c031612-8370-407e-8477-34a3969099e5';

export const SEARCH_WDS_ICONS = '9767c8c9-71cd-4b24-9914-ef72dafc3b41';
export const UI_PLAN_PROMPT = 'f4581a4a-7a72-4e62-a27d-592d9a8d6784';

export const TAG_PROMPT = 'f42497d1-c9d7-4958-8edc-0dbe88566fd4';
export const TAG_PROMPT_BASIC = '55af02ea-b5c8-41b6-a322-d7f9256f900c';
export const SUMMRISE_INTRO_PROMPT = 'a7011dee-fbdc-4b9d-b5b0-815e1692dfc6';

export const WDS_CODING_EXPERT = '8db0a776-9a28-4d4b-be40-e58155e2ff23';
export const SEARCH_WIXTRO_DOCS_PROMPT_ID =
  '4b27e087-4ac0-4254-a21d-57cb3a54fa38';

export const PROMPT_ID_TO_NAME: Record<string, string> = {
  [SEARCH_DOCS_PROMPT_ID_NEW]: 'Search Docs',
  [SEARCH_DOCS_PROMPT_ID_MINI]: 'Search Docs Mini',
  [SEARCH_DOCS_PROMPT_ID_STREAM]: 'Search Docs Stream',
  [SEARCH_DOCS_PROMPT_ID_STREAM_MINI]: 'Search Docs Stream Mini',
  [VERY_SHORT_SUMMARY_PROMPT_ID]: 'Very Short Summary',
  [SEARCH_RELEVANT_METHODS_PROMPT_ID]: 'Search Relevant Methods',
  [GENERATE_SDK_CODE_EXAMPLE_PROMPT_ID]: 'Generate SDK Code Example',
  [GENERATE_VELO_CODE_EXAMPLE_PROMPT_ID]: 'Generate Velo Code Example',
  [GENERATE_REST_CODE_EXAMPLE_PROMPT_ID]: 'Generate REST Code Example',
  [SYNTH_CODE_EXAMPLE_PROMPT_ID]: 'Synth Code Example',
  [SYNTH_CODE_EXAMPLE_PROMPT_ID_VELO]: 'Synth Code Example Velo',
  [SEARCH_REST_RELEVANT_METHODS_PROMPT_ID]:
    'Search REST / VELO Relevant Methods',

  [DOCS_SCHEMA_SUMMARY_PROMPT_ID]: 'Docs Schema Summary',
  [DOCS_SCHEMA_SUMMARY_PROMPT_ID_REST]: 'Docs Schema Summary REST',
  [EVAL_PROMPT_ID]: 'Eval',
  [SEARCH_DOCS_AND_CODE_PROMPT_ID]: 'Search Docs and Code',
  [SEARCH_WDS_DOCS_AND_CODE_PROMPT_ID]: 'Search WDS Docs and Code',
};

export enum Portal {
  PUBLIC_SDK = 'PUBLIC_SDK',
  VELO = 'VELO',
  REST = 'REST',
  BUILD_APPS = 'BUILD_APPS',
  UNKNOWN = 'UNKNOWN',
}

export const SDK_DOMAIN_ID = 'bfa63db2-8f2b-4bd0-8ae1-dc9bde484736';
export const REST_DOMAIN_ID = '880f40cb-d98e-46f8-adf7-79cb3faa7e6e';
export const BUILD_APPS_DOMAIN_ID = '0f9abc08-51eb-4836-aa53-14522f5e53c7';
export const VELO_DOMAIN_ID = '77e3ab76-6509-43c3-8424-4102cb9a2a3e';
export const UNIFIED_ASSISTANT_DOMAIN_ID = {
  domainId: '5e9a9fda-5d98-4339-8ebd-d7721e790b67',
  options: {
    revisionTag:
      '9afecb2f-b53d-402b-ab37-e6bd6787c784:d3055335-879a-4fc0-a332-e896177c57fc',
  },
};

export const SDK_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/sdk';
export const PICASSO_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/picasso';
export const REST_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/rest';
export const BUILD_APPS_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/build-apps';
export const HEADLESS_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/go-headless';
export const DEVELOP_WEBSITES_DOCS_URL_PREFIX =
  'https://dev.wix.com/docs/develop-websites';
export const VELO_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/velo';
export const FEDS_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/fed-guild';
export const BEDS_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/server-guild';
export const RND_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/rnd-general';
export const WIXTRO_DOCS_URL_PREFIX = 'https://dev.wix.com/docs/test';

export const PORTAL_ID_TO_DOCS_URL_PREFIX: Record<string, string> = {
  [SDK_PORTAL_ID]: SDK_DOCS_URL_PREFIX,
  [REST_PORTAL_ID]: REST_DOCS_URL_PREFIX,
  [VELO_PORTAL_ID]: VELO_DOCS_URL_PREFIX,
  [BUILD_APPS_PORTAL_ID]: BUILD_APPS_DOCS_URL_PREFIX,
  [HEADLESS_PORTAL_ID]: HEADLESS_DOCS_URL_PREFIX,
  [DEVELOP_WEBSITES_PORTAL_ID]: DEVELOP_WEBSITES_DOCS_URL_PREFIX,
  [WIXTRO_PORTAL_ID]: WIXTRO_DOCS_URL_PREFIX,
};

interface AssistantConfig {
  niceName: string;
  domainId?: string | { domainId: string; options: Record<string, string> };
  portalId?: string;
  // kbId: string;
  promptId?: string;
  docsUrlPrefix?: string;
  firstUserMessage: string;
}

export const ASSISTANT_CONFIG: Record<string, AssistantConfig> = {
  SDK: {
    niceName: 'SDK',
    domainId: SDK_DOMAIN_ID,
    portalId: SDK_PORTAL_ID,
    // kbId: SDK_DOCS_KB_ID,
    promptId: SEARCH_DOCS_PROMPT_ID_NEW,
    docsUrlPrefix: SDK_DOCS_URL_PREFIX,
    firstUserMessage: 'What can you do?',
  },
  REST: {
    niceName: 'REST',
    domainId: REST_DOMAIN_ID,
    portalId: REST_PORTAL_ID,
    // kbId: REST_DOCS_KB_ID,
    promptId: SEARCH_DOCS_PROMPT_ID_NEW,
    docsUrlPrefix: REST_DOCS_URL_PREFIX,
    firstUserMessage: 'What can you do?',
  },
  BUILD_APPS: {
    niceName: 'Apps',
    domainId: BUILD_APPS_DOMAIN_ID,
    portalId: BUILD_APPS_PORTAL_ID,
    // kbId: BUILD_APPS_KB_ID,
    promptId: '',
    docsUrlPrefix: BUILD_APPS_DOCS_URL_PREFIX,
    firstUserMessage: 'What can you do?',
  },
  HEADLESS: {
    niceName: 'Headless',
    domainId: HEADLESS_PORTAL_ID,
    portalId: HEADLESS_PORTAL_ID,
    // kbId: HEADLESS_KB_ID,
    promptId: '',
    docsUrlPrefix: HEADLESS_DOCS_URL_PREFIX,
    firstUserMessage: 'What can you do?',
  },
  DEVELOP_WEBSITES: {
    niceName: 'Websites Dev',
    domainId: DEVELOP_WEBSITES_PORTAL_ID,
    portalId: DEVELOP_WEBSITES_PORTAL_ID,
    // kbId: DEVELOP_WEBSITES_KB_ID,
    promptId: '',
    docsUrlPrefix: DEVELOP_WEBSITES_DOCS_URL_PREFIX,
    firstUserMessage: 'What can you do?',
  },
  VELO: {
    niceName: 'Velo',
    domainId: VELO_DOMAIN_ID,
    portalId: VELO_PORTAL_ID,
    // kbId: VELO_DOCS_KB_ID,
    promptId: SEARCH_DOCS_PROMPT_ID_NEW,
    docsUrlPrefix: VELO_DOCS_URL_PREFIX,
    firstUserMessage: 'Hi :) What can you do?',
  },
  UNIFIED: {
    niceName: 'Docs',
    domainId: UNIFIED_ASSISTANT_DOMAIN_ID,
    docsUrlPrefix: '',
    firstUserMessage: 'What can you do?',
  },
  WDS: {
    niceName: 'Design System',
    domainId: '5e9a9fda-5d98-4339-8ebd-d7721e790b67',
    docsUrlPrefix: '',
    firstUserMessage: 'What can you do?',
  },
  CAIRO: {
    niceName: 'Patterns',
    domainId: '5e9a9fda-5d98-4339-8ebd-d7721e790b67',
    docsUrlPrefix: '',
    firstUserMessage: 'What can you do?',
  },
  WIXTRO: {
    niceName: 'Wixtro',
    domainId: '5e9a9fda-5d98-4339-8ebd-d7721e790b67',
    docsUrlPrefix: '',
    firstUserMessage: 'What can you do?',
  },
};

export const STORES_PRODUCTS_RESOURCE_ID_SDK =
  'c25ced1f-7f72-4f8c-9698-f8ea09396cd0';
export const STORES_CATALOG_RESOURCE_ID_REST =
  'f4df6095-927c-469f-8541-d1dd0d33f547';
export const BLOG_DRAFT_POSTS_RESOURCE_ID_REST =
  '6aa0871d-a332-4f61-8d89-87c12bbb7c0a';
export const STORES_PRODUCTS_RESOURCE_ID_VELO =
  '97ad5813-4054-4d78-9ac6-95ee209e7cc9';
export const $W_VELO_RESOURCE_ID = '4226f67a-73d7-47fd-acd0-e8e474f9f390';

export const assistantTypeToToolName: Record<string, string> = {
  SDK: 'searchWixSDKDocumentationAndSummarize',
  REST: 'searchWixRESTDocumentationAndSummarize',
  VELO: 'searchWixVeloDocumentationAndSummarize',
  BUILD_APPS: 'searchWixAppsDocumentationAndSummarize',
  UNIFIED: 'searchWixUnifiedDocumentationAndSummarize',
  HEADLESS: 'searchWixHeadlessDocumentationAndSummarize',
  DEVELOP_WEBSITES: 'searchWixDevSitesDocumentationAndSummarize',
  CAIRO: 'searchWixCairoDocumentationAndSummarize',
  WDS: 'searchWixWDSDocumentation',
  WIXTRO: 'searchWixtroDocumentation',
};

export const IGOR_RESOURCE_UPDATED_TOPIC = 'igor_resource_updated';
